import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/HomePage";
import About from "./pages/About";
import Layout from "./components/layout";
import Service from "./pages/Services";
import Incorporation from "./pages/AllServices/Incorporation";
import Accounting from "./pages/AllServices/Accounting";
import Taxation from "./pages/AllServices/Taxation";
import Sole_Proprietorship from "./pages/AllServices/Sole_Proprietorship";
import Partnership_Firm from "./pages/AllServices/Partnership_Firm";
import Limited_Liability from "./pages/AllServices/Limited_Liability";
import One_Person_Company from "./pages/AllServices/One_Person_Company";
import PrivateLimitedCompany from "./pages/AllServices/PrivateLimitedCompany";
import PublicLimitedCompany from "./pages/AllServices/PublicLimitedCompany";
import Direct_Tax_Services from "./pages/AllServices/Direct_Tax_Services";
import Income_tax from "./pages/AllServices/IncomeTax";
import Corporate_Tax from "./pages/AllServices/Corporate_Tax";
import International_Tax_Services from "./pages/AllServices/International_Tax_Services";
import Transfer_Pricing from "./pages/AllServices/Transfer_Pricing";
import DTAA_Advisory from "./pages/AllServices/DTAA_Advisory";
import NRI_Taxatios from "./pages/AllServices/NRI_Taxatios";
import Indirect_Tax_Service from "./pages/AllServices/Indirect_Tax_Service";
import GST_Compliance from "./pages/AllServices/GST_Compliance";
import Blogs from "./pages/Blogs";
import Blog_Details from "./pages/Blog_Details";
import GST_Due_Diligence_Services from "./pages/AllServices/GST_Due_Diligence_Services";
import GST_Opinion_Services from "./pages/AllServices/GST_Opinion_Services";
import GST_Classification_Services from "./pages/AllServices/GST_Classification_Services";
import GST_Litigation_Services from "./pages/AllServices/GST_Litigation_Services";
import GST_Search_Inquiry_Support_Services from "./pages/AllServices/GST_Search_Inquiry_Support_Services";
import E_Way_Bill_Consultancy_Services from "./pages/AllServices/E_Way_Bill_Consultancy_Services";
import GST_Refund_Services from "./pages/AllServices/GST_Refund_Services";
import Specialized_Tax_Services from "./pages/AllServices/Specialized_Tax_Services";
import GST_Return_Preparation_Services from "./pages/AllServices/GST_Return_Preparation_Services";
import Audit_And_Assurance_Services from "./pages/AllServices/Audit_And_Assurance_Services";
import Statutory_Audit_Services from "./pages/AllServices/Statutory_Audit_Services";
import Internal_Audit_Services from "./pages/AllServices/Internal_Audit_Services";
import Tax_Audit_Services from "./pages/AllServices/Tax_Audit_Services";
import Forensic_Audit_Services from "./pages/AllServices/Forensic_Audit_Services";
import ConsultancyServices from "./pages/AllServices/Consultancy_services";
import BusinessAdvisory from "./pages/AllServices/Business_Advisory&Corporate_Strategy";
import GST_Audit_Services from "./pages/AllServices/GST_Audit_Services";
import RiskComplianceConsultancy from "./pages/AllServices/risk&compliance-consultancy";
import StartupSMEConsultancy from "./pages/AllServices/Startup&sme_consultancy";
import FinanceConsultancy from "./pages/AllServices/Finance_Consultancy";
import Concurrent_Audit_Services from "./pages/AllServices/Concurrent_Audit_Services";
import CorporateFinance from "./pages/AllServices/Corporate_finance&transaction_advisory";
import ITdigital_Transformation from "./pages/AllServices/IT&Digital_transformation_advisory";
import Compliance_Audit_Services from "./pages/AllServices/Compliance_Audit_Services";
import Information_System_Audit_Services from "./pages/AllServices/Information_System_Audit_Services";
import Management_Audit_And_Risk_Assessment_Services from "./pages/AllServices/Management_Audit_And_Risk_Assessment_Services";
import Departmental_And_Process_Audit_Services from "./pages/AllServices/Departmental_And_Process_Audit_Services";
import Wealth_Trust_Succession_planning from "./pages/AllServices/Wealth_Trust&Succession_planning";

function App() {
  return (
    <Router>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Service />} />
              <Route path="/incorporation" element={<Incorporation />} />
              <Route path="/accounting" element={<Accounting/>} />
              <Route path="/taxation" element={<Taxation/>} />
              <Route path="/sole-proprietorship" element={<Sole_Proprietorship/>} />
              <Route path="/partnership-firm" element={<Partnership_Firm/>} />
              <Route path="/limited-liability" element= {<Limited_Liability/>} />
              <Route path="/one-person-company" element= {<One_Person_Company/>} />
              <Route path="/private-limited-company" element= {<PrivateLimitedCompany/>} />
              <Route path="/public-limited-company" element= {<PublicLimitedCompany/>} />
              <Route path="/direct-tax-services" element= {<Direct_Tax_Services/>} />
              <Route path="/income-tax" element= {<Income_tax/>} />
              <Route path="/corporate-tax" element= {<Corporate_Tax/>} />
              <Route path="/international-tax-services" element={<International_Tax_Services/>} />
              <Route path="/transfer-pricing" element= {<Transfer_Pricing/>} />
              <Route path="/dtaa-advisory" element= {<DTAA_Advisory/>} />
              <Route path="/nri-taxatios" element={<NRI_Taxatios/>} />
              <Route path="/indirect-tax-service" element={<Indirect_Tax_Service/>} />
              <Route path="/gst-compliance" element= {<GST_Compliance/>} />
              <Route path="/gst-due-diligence-services" element= {<GST_Due_Diligence_Services/>} />
              <Route path="/gst-opinion-services" element= {<GST_Opinion_Services/>} />
              <Route path="/gst-classification-services" element= {<GST_Classification_Services/>} />
              <Route path="/gst-litigation-services" element= {<GST_Litigation_Services/>} />
              <Route path="/e-way-bill-consultancy-services" element= {<E_Way_Bill_Consultancy_Services/>} />
              <Route path="/gst-refund-services" element= {<GST_Refund_Services/>} />
              <Route path="/specialized_tax-services" element= {<Specialized_Tax_Services/>} />
              <Route path="/gst-return-preparation-services" element= {<GST_Return_Preparation_Services/>} />
              <Route path="/audit-and-assurance-services" element= {<Audit_And_Assurance_Services/>} />
              <Route path="/statutory-audit-services" element= {<Statutory_Audit_Services/>} />
              <Route path="/internal-audit-services" element= {<Internal_Audit_Services/>} />
              <Route path="/tax-audit-services" element= {<Tax_Audit_Services/>} />
              <Route path="/forensic-audit-services" element= {<Forensic_Audit_Services/>} />
              <Route path="/consultancy-services" element= {<ConsultancyServices/>} />
              <Route path="/business-advisory&corporate-strategy" element= {<BusinessAdvisory/>} />
              <Route path="/gst-audit-services" element= {<GST_Audit_Services/>} />
              <Route path="/risk&compliance-consultancy" element= {<RiskComplianceConsultancy/>} />
              <Route path="/startup&sme-consultancy" element= {<StartupSMEConsultancy/>} />
              <Route path="/finance-consultancy" element= {<FinanceConsultancy/>} />
              <Route path="/concurrent-audit-services" element= {<Concurrent_Audit_Services/>} />
              <Route path="/corporate-finance&transaction-advisory" element= {<CorporateFinance/>} />
              <Route path="/it&digital-transformation-advisory" element= {<ITdigital_Transformation/>} />
              <Route path="/compliance-audit-services" element= {<Compliance_Audit_Services/>} />
              <Route path="/information-system-audit-services" element= {<Information_System_Audit_Services/>} />
              <Route path="/management-audit&risk-assessment-services" element= {<Management_Audit_And_Risk_Assessment_Services/>} />
              <Route path="/departmental&process-audit-services" element= {<Departmental_And_Process_Audit_Services/>} />
              <Route path="/wealth-trust&succession-planning" element= {<Wealth_Trust_Succession_planning/>} />

              <Route path="/gst-search-inquiry-support-services" element= {<GST_Search_Inquiry_Support_Services/>} />
              <Route path="/Blogs" element= {<Blogs/>} />
              <Route path="/blog/:blogSlug" element={<Blog_Details />} />
            </Route>
          </Routes>
    </Router>
  );
}

export default App;